import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c94e7c9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-address" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " Billing Address ", -1))
const _hoisted_3 = { class: "box-addresses" }
const _hoisted_4 = {
  key: 0,
  class: "current-address"
}
const _hoisted_5 = { class: "card-address checked" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Use Shipping Address", -1))
const _hoisted_7 = { class: "card-address" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Use A Different Address", -1))

import { ref } from 'vue';
  import { ColorVariants } from '@/constants';

  interface IProps {
    readonly?: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    readonly: { type: Boolean }
  },
  setup(__props: any) {

  
  const dialogVisible = ref(false);
  const addressForm = ref({});

  function handleFormChange(data: any) {
    addressForm[data.key] = data.value;
  }

  function handleSaveAddress() {
    dialogVisible.value = false;
  }

  function handleAdd() {
    addressForm.value = {};
    dialogVisible.value = true;
  }


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AppRadio = _resolveComponent("AppRadio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppDialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      title: "Create bill address",
      btns: [
      { text: 'Close', style: _unref(ColorVariants).outlinePrimary, click: () => dialogVisible.value = false },
      { text: 'Save', style: _unref(ColorVariants).primary, click: () => handleSaveAddress() }
    ]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form, { class: "address-form" }, {
          default: _withCtx(() => [
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: 'First Name',
          type: 'input',
          key: 'first_name',
          required: true,
        },
              form: addressForm.value,
              onChange: handleFormChange
            }, null, 8, ["form"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (__props.readonly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Edward Chan，Tianhe District, Guangzhou，Room 1110 Poly Clovis Plaza, #9，New York，NY10001，United Stated "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_AppRadio, {
                  class: "radio",
                  "model-value": ""
                }),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AppRadio, {
                  class: "radio",
                  "onUpdate:modelValue": handleAdd
                }),
                _hoisted_8
              ])
            ], 64))
      ])
    ])
  ], 64))
}
}

})